import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import useTemplateHook from '../template/templateHook'
import { useTranslation } from 'react-i18next'
import Profile from '../../assets/profile'
import Watchlist from '../../assets/myWatchlist'
import Favorite from '../../assets/favorite'
import Subscription from '../../assets/subscription'
import Transaction from '../../assets/transaction'
import ChangePlan from '../../assets/changePlan'
import HandBag from '../../assets/handBag'
import SignOut from '../../assets/signOut'
import Cart from '../../assets/cart'
import OrderHistory from '../../assets/orderHistory'
import Wishlist from '../../assets/wishlist'
import Address from '../../assets/address'
import { AppContext } from '../../context/app'
import styled from '@emotion/styled'

const StyledListItem = styled.li`
  .dropdown-list {
    background-color: ${(props) => props.background};
  }
  .dropdown-list:hover {
    background-color: ${(props) => props.backgroundHover};
  }
`

const TabNavDropdown = ({
  titleColor,
  borderTop,
  backgroundColor = 'transparent',
  isLeftAligned = false,
  useWhiteBorder = false,
  getStyleValue = () => {},
}) => {
  const { t } = useTranslation()
  const [openShop, setOpenShop] = useState(false)
  const { logoutCall, handleSubscription } = useTemplateHook()
  const { modulePermissions } = useContext(AppContext)

  const finalBorderTop = useWhiteBorder ? '1.5px solid white' : borderTop

  const justifyClass = isLeftAligned ? 'justify-start' : 'justify-center'

  const paddingClass = isLeftAligned ? 'pl-5' : ''

  const paddingClassShop = isLeftAligned ? 'pl-12' : ''
  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        right: '0px',
        top: '10px',
        boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
      }}
      className="min-w-[184px] absolute rounded "
    >
      <ul className="" style={{ color: titleColor }}>
        <li className="">
          <Link to="/profile" className={`flex items-center ${justifyClass} ${paddingClass} `}>
            <Profile height="13px" width="13px" />
            <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('my_profile')}
            </p>
          </Link>
        </li>

        <li style={{ borderTop: finalBorderTop }} className="">
          <Link to="/watchlist" className={`flex ${justifyClass} ${paddingClass} items-center `}>
            <Watchlist height="13px" width="13px" />
            <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('my_watchlist')}
            </p>
          </Link>
        </li>

        <li style={{ borderTop: finalBorderTop }} className="">
          <Link to="/favourites" className={`flex ${justifyClass} ${paddingClass} items-center `}>
            <Favorite height="13px" width="13px" />
            <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('my_favorites')}
            </p>
          </Link>
        </li>

        <li
          style={{ borderTop: finalBorderTop }}
          className={`flex ${justifyClass} ${paddingClass} items-center `}
        >
          <Link to="/subscriptions" className="flex items-center ">
            <Subscription height="13px" width="13px" />
            <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('my_subscriptions')}
            </p>
          </Link>
        </li>

        <li
          style={{ borderTop: finalBorderTop }}
          className={`flex ${justifyClass} ${paddingClass} items-center `}
        >
          <Link to="/transactions" className="flex items-center ">
            <Transaction height="13px" width="13px" />
            <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('Transactions')}
            </p>
          </Link>
        </li>

        <li
          style={{ borderTop: finalBorderTop }}
          className={`flex ${justifyClass} ${paddingClass} items-center `}
          onClick={handleSubscription}
        >
          <ChangePlan height="13px" width="13px" />
          <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
            {t('change_plan')}
          </p>
        </li>

        {!modulePermissions?.ecommerce ? (
          <>
            <li
              style={{ borderTop: finalBorderTop }}
              className={`flex ${justifyClass} ${paddingClass} items-center  cursor-pointer`}
              onClick={() => setOpenShop(!openShop)}
            >
              <HandBag height="13px" width="13px" />
              <p className="text-xs block pl-2 pr-1 py-1 my-1  user-dropdown-menu">Shop</p>
              <svg
                className={
                  openShop
                    ? 'rotate-profile-arrow w-3 h-3  mt-1'
                    : 'reset-profile-arrow w-3 h-3  mt-1'
                }
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </li>
            <ul className={`${openShop ? 'block' : 'hidden'} w-full`}>
              <StyledListItem
                background={`${getStyleValue('component_background', 'primary_color', '#000000')}`}
                backgroundHover={`${getStyleValue('highlighter_color', 'color', '#fecc00')}`}
              >
                <li
                  className={`flex ${justifyClass} ${paddingClassShop} items-center dropdown-list`}
                >
                  <Link to="/cart-details" className="flex items-center ">
                    <Cart height="13px" width="13px" />
                    <p className="text-xs block px-2 py-1 my-1 user-dropdown-menu">My Cart</p>
                  </Link>
                </li>
              </StyledListItem>
              <StyledListItem
                background={`${getStyleValue('component_background', 'primary_color', '#000000')}`}
                backgroundHover={`${getStyleValue('highlighter_color', 'color', '#fecc00')}`}
              >
                <li
                  className={`flex ${justifyClass} ${paddingClassShop} items-center dropdown-list`}
                >
                  <Link to="/order-history" className="flex items-center ">
                    <OrderHistory height="13px" width="13px" />
                    <p className="text-xs block px-2 py-1 my-1 user-dropdown-menu">Order History</p>
                  </Link>
                </li>
              </StyledListItem>
              <StyledListItem
                background={`${getStyleValue('component_background', 'primary_color', '#000000')}`}
                backgroundHover={`${getStyleValue('highlighter_color', 'color', '#fecc00')}`}
              >
                <li
                  className={`flex ${justifyClass} ${paddingClassShop} items-center dropdown-list`}
                >
                  <Link to="/wish-list" className="flex items-center ">
                    <Wishlist height="13px" width="13px" />
                    <p className="text-xs block px-2 py-1 my-1 user-dropdown-menu">Wishlist</p>
                  </Link>
                </li>
              </StyledListItem>
              <StyledListItem
                background={`${getStyleValue('component_background', 'primary_color', '#000000')}`}
                backgroundHover={`${getStyleValue('highlighter_color', 'color', '#fecc00')}`}
              >
                <li
                  className={`flex ${justifyClass} ${paddingClassShop} items-center dropdown-list`}
                >
                  <Link to="/manage-address" className="flex items-center ">
                    <Address height="13px" width="13px" />
                    <p className="text-xs block px-2 py-1 my-1 user-dropdown-menu">My Addresses</p>
                  </Link>
                </li>
              </StyledListItem>
            </ul>
          </>
        ) : null}

        <li
          style={{ borderTop: finalBorderTop }}
          className={`flex ${justifyClass} ${paddingClass} items-center `}
          onClick={logoutCall}
        >
          <SignOut height="13px" width="13px" />
          <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
            {t('sign_out')}
          </p>
        </li>
      </ul>
    </div>
  )
}

export default TabNavDropdown
